import { DateInput } from "@mantine/dates";

import Styles from "../Calendar/Calendar.module.css";

export const dateInputOverrides = {
  DateInput: DateInput.extend({
    defaultProps: {
      size: "md",
      inputWrapperOrder: ["label", "description", "input", "error"],
    },
    classNames: {
      levelsGroup: Styles.popoverWrapper, // weird name for a popover wrapper
      day: Styles.day,
      weekday: Styles.weekday,
      month: Styles.month,
      monthRow: Styles.row,
      monthCell: Styles.cell,
      monthsList: Styles.monthsList,
      monthsListRow: Styles.row,
      monthsListCell: Styles.cell,
      monthsListControl: Styles.monthsListControl,
      yearsList: Styles.yearsList,
      yearsListRow: Styles.row,
      yearsListCell: Styles.cell,
      calendarHeader: Styles.calendarHeader,
      calendarHeaderLevel: Styles.calendarHeaderLevel,
      calendarHeaderControl: Styles.calendarHeaderControl,
      input: Styles.input,
      error: Styles.error,
    },
    styles: {
      levelsGroup: {
        gap: "var(--mantine-spacing-lg)",
      },
    },
  }),
};
